import { render, staticRenderFns } from "./TagSelectBloc.vue?vue&type=template&id=2bec4a55&scoped=true"
import script from "./TagSelectBloc.js?vue&type=script&lang=js&external"
export * from "./TagSelectBloc.js?vue&type=script&lang=js&external"
import style0 from "./TagSelectBloc.scss?vue&type=style&index=0&id=2bec4a55&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec4a55",
  null
  
)

export default component.exports